export enum PluginName {
	TEAMWORK = 'teamwork',
	PAGE_SEARCH_PLUGIN = 'Page-Search-Plugin',
	SEARCH = 'search',
	PEOPLE = 'people',
}
